<template>
  <div class="page-shell class-course-page">
    <MobileTopNav title="班课课程" />
    <main class="class-course-placeholder"></main>
  </div>
</template>

<script>
import MobileTopNav from '../components/MobileTopNav.vue'

export default {
  name: 'ClassCourseView',
  components: {
    MobileTopNav
  },
  mounted() {
    document.title = '班课课程'
  }
}
</script>

<style scoped>
.class-course-page {
  min-height: 100vh;
  background: #fff;
}

.class-course-placeholder {
  min-height: calc(100vh - 48px);
}
</style>
